module.exports = __webpack_public_path__ + "static/media/starts_with_k.fd558297.mp3";